import { type Browser, browserName, detectOS, type OperatingSystem } from 'detect-browser';
import Cookies from 'js-cookie';
import { type ModalResponse, ModalService } from '../components/modal/modal.service';
import { T, Translate } from '../i18n';
import { m } from '../mithril';

const compatibleBrowsers = ['edge', 'edge-ios', 'edge-chromium', 'chrome', 'chromium-webview', 'firefox'];
const incompatibleOS = ['iOS', 'Android OS', 'BlackBerry OS', 'Windows Mobile'];

const USE_INCOMPATIBLE_BROWSER_OS = 'useIncompatibleBrowserOS';
const EXPIRY_COOKIE_DAYS = 1;

export class BrowserCheck {
	browser: Browser;
	os: OperatingSystem;

	constructor() {
		this.browser = browserName(navigator.userAgent);
		this.os = detectOS(navigator.userAgent);
	}

	async validateBrowser() {
		const dismissedMessageCookie = Cookies.get(USE_INCOMPATIBLE_BROWSER_OS);

		if (dismissedMessageCookie) {
			return;
		}

		let result: ModalResponse = { ok: false, cancel: false };

		if (incompatibleOS.includes(this.os)) {
			result = await ModalService.open({
				title: T.MESSAGE_MOBILE_VALIDATION_TITLE,
				content: Translate(T.MESSAGE_MOBILE_VALIDATION_CONTENT),
				hasCancel: false,
				canClose: () => true,
			});
		} else if (!compatibleBrowsers.includes(this.browser)) {
			result = await ModalService.open({
				title: T.MESSAGE_BROWSER_VALIDATION_TITLE,
				content: () =>
					m('div', [
						m('span', Translate(T.MESSAGE_BROWSER_VALIDATION_CONTENT)),
						m(
							'a',
							{ href: Translate(T.MESSAGE_BROWSER_VALIDATION_URL), target: '_blank' },
							Translate(T.MESSAGE_BROWSER_VALIDATION_URL_TEXT)
						),
					]),
				hasCancel: false,
				canClose: () => true,
			});
		}

		if (result.ok) {
			Cookies.set(USE_INCOMPATIBLE_BROWSER_OS, '1', { expires: EXPIRY_COOKIE_DAYS });
		}
	}
}
